var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "seu-email-input"
  }, [_c('mailchimp-subscribe', {
    attrs: {
      "url": "https://seu.us21.list-manage.com/subscribe/post-json",
      "user-id": "4ea7f6f2af0b649dadd05429c",
      "list-id": _vm.listId
    },
    on: {
      "error": _vm.onError,
      "success": _vm.onSuccess
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var subscribe = _ref.subscribe,
          setEmail = _ref.setEmail,
          error = _ref.error,
          success = _ref.success,
          loading = _ref.loading;
        return [_c('div', {
          staticClass: "mailchimp-subscribe-form"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.email,
            expression: "email"
          }],
          staticClass: "paragraph-1-large",
          attrs: {
            "type": "text",
            "placeholder": _vm.placeholder
          },
          domProps: {
            "value": _vm.email
          },
          on: {
            "input": [function ($event) {
              if ($event.target.composing) return;
              _vm.email = $event.target.value;
            }, function ($event) {
              return setEmail($event.target.value);
            }]
          }
        }), _vm.$v.email.$error ? _c('div', [_vm._v(" " + _vm._s(_vm.$t('newsletter.email_required')))]) : _vm._e(), _c('seu-button', {
          attrs: {
            "label": _vm.buttonLabel,
            "button-icon-before": _vm.arrowIcon
          },
          on: {
            "click": function ($event) {
              return _vm.submitForm(subscribe);
            }
          }
        })], 1)];
      }
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }